function findAllJawTooths() {
  let tooths = [];

  let paths = document.getElementsByTagName('path');
  if (!paths.length) {
    return;
  }

  for (let item of paths) {
    if (!item.classList.contains('tooth')) {
      continue;
    }

    tooths.push(item);
  }

  return tooths;
}

function resetJawTooths(tooths) {
  if (!tooths.length) {
    return;
  }

  for (let item of tooths) {
    item.classList.remove('selected', 'active');
  }
}

function attachJawToothEvents(tooths, callbacks) {
  if (!tooths.length) {
    return;
  }

  for (let item of tooths) {
    item.addEventListener('mouseover', (event) => hoverJawTooth(event, callbacks.hover));
    item.addEventListener('mouseout', (event) => hoverJawTooth(event, callbacks.hover));
    item.addEventListener('click', (event) => selectJawTooth(event, callbacks.click));
  }
}

function hoverJawTooth(event, callback) {
  if (!event) {
    return;
  }

  if (!event.target.classList.contains('tooth')) {
    return;
  }

  let toothClass = event.target.getAttribute('class').match(/[a-z\-\d]*tooth-\d*/);
  if (!toothClass.length) {
    return;
  }

  if (!document.getElementsByClassName(toothClass + '-parent')[0]) {
    return;
  }

  let toothParent = document.getElementsByClassName(toothClass + '-parent')[0];
  let toothNumber = parseInt(toothClass[0].split('-').pop());
  if (toothParent.classList.contains('active')) {
    toothParent.classList.remove('active');
  } else {
    toothParent.classList.add('active');
  }

  callback({
    number: toothNumber,
    item: toothParent,
  });
}

function selectJawTooth(event, callback) {
  if (!event) {
    return;
  }

  if (!event.target.classList.contains('tooth')) {
    return;
  }

  let toothClass = event.target.getAttribute('class').match(/[a-z\-\d]*tooth-\d*/);
  if (!toothClass.length) {
    return;
  }

  let toothParent = document.getElementsByClassName(toothClass + '-parent')[0];
  let toothNumber = parseInt(toothClass[0].split('-').pop());

  callback({
    number: toothNumber,
    item: toothParent,
  });
}

export {
  findAllJawTooths,
  resetJawTooths,
  attachJawToothEvents,
  hoverJawTooth,
  selectJawTooth,
};
